import assign from 'object-assign';
import { EventEmitter } from 'events';

import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

const CHANGE_EVENT = 'STRIPE_ACCOUNTS_STORE_CHANGE';

let accountInfo = {};

const StripeAccountsStore = assign({}, EventEmitter.prototype, {
  emitChange(change) {
    this.emit(CHANGE_EVENT, change);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  getAccountInfo() {
    return accountInfo;
  },

  setAccountInfo(data) {
    accountInfo = data;
    this.emitChange();
  },
});

StripeAccountsStore.dispatchToken = AdminAppDispatcher.register((payload) => {
  const action = payload.action;

  switch (action.type) {
    case ActionTypes.RECEIVE_BANK_ACCOUNTS:
      StripeAccountsStore.setAccountInfo(action.data);
      break;
    default:
      break;
  }
});

export default StripeAccountsStore;
